// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"c9acac585ba53e351c78","678":"fa5666b6502f37599010","883":"13a218c5df93b21ee69f"}[chunkId] + ".js";
};